(function ($) {

    if ($('.block--quote').length > 0) {
        $(".block--quote__more").on('click', function() {
            $('.block--quote').toggleClass('open');
        })
    }

})(jQuery);